import s from './AppStatusChip.module.scss';

/**
 * AppStatusChip — pillola di stato.
 *
 * Variants (mappate alle famiglie semantiche del DESIGN.md):
 *   neutral, teal, success, warning, danger, info, purple, pink, primary.
 *
 * `fullCell` (default true) stira la chip per riempire la cella di un
 * DataGrid usando un accent border-left. Per uso inline / card passare
 * `fullCell={false}` (renderizza la chip con bordo standard e radius).
 *
 * `solid` (default false) rende la chip a pillola con colore PIENO (sfondo
 * saturo + testo a contrasto). Pensata per lo stato in evidenza nelle card.
 * Quando attiva ha precedenza su `fullCell`.
 *
 * `icon` (opzionale) — nome icona FontAwesome SENZA prefisso `fa-solid fa-`
 * (lo aggiunge il componente).
 */
export default function AppStatusChip({
  variant = 'neutral',
  label,
  icon,
  dot = false,
  fullCell = true,
  solid = false,
  onClick,
  sx,
}) {
  const variantClass = s[variant] || s.neutral;

  const classes = [
    s.chip,
    solid ? s.solid : fullCell ? s.fullCell : s.inline,
    variantClass,
    icon || dot ? s.withIcon : null,
    onClick ? s.clickable : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} title={label} onClick={onClick} style={sx}>
      {dot ? <span className={s.dot} aria-hidden="true" /> : null}
      {icon ? <i className={`fa-solid fa-${icon}`} /> : null}
      {label}
    </div>
  );
}
